import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../image/hifi.png";
import { getData } from "../api/protectedApi";

const DashboardNavbar = () => {
  const [userName, setUserName] = useState("");


  const getUserProfile = async () => {
    try {
      const res = await getData("/profile");
      if (res?.data?.user_data?.name) {
        setUserName(res.data.user_data.name);
      }
    } catch (error) {
      console.error("Failed to fetch user data", error);
    }
  };

  useEffect(() => {
    getUserProfile()
  }, []);

  const firstLetter = userName
    ? userName.charAt(0).toUpperCase()
    : "U";

    
  return (
    <div className="container-fluid pt-3">
      <nav className="custom-navbar d-flex align-items-center justify-content-between ">

        {/* Logo */}
        <div className="logo">
          <img src={logo} alt="Logo" />
        </div>

        {/* Right Menu */}
        <div className="d-flex align-items-center gap-3 ">
          <Link to="/dashboard" className="nav-pill">Home</Link>
          <Link to="/directteam" className="nav-pill">My Directs</Link>
          <Link to="/myteam" className="nav-pill">My Team</Link>

          {/* PROFILE DROPDOWN */}
          <Dropdown align="end">
            <Dropdown.Toggle
              as="div"
              className="profile-circle"
              role="button"
            >
              {firstLetter}
            </Dropdown.Toggle>

            <Dropdown.Menu className="profile-dropdown">
              <Dropdown.Item as={Link} to="/editprofile">
                <i className="fa fa-user-edit me-2"></i> Edit Profile
              </Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Item className="text-danger" as={Link} to="/">
                <i className="fa fa-sign-out-alt me-2"></i> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </nav>
    </div>
  );
};

export default DashboardNavbar;
